/**
 * Header bar with africanDRONE branding, primary nav (News, Opportunities,
 * Resources), and "Suggest an Update" + WhatsApp buttons.
 */

/** Handlers for the header nav entry points. These call the same actions as
 *  the corner layer-panel buttons (wired in main.ts). */
export interface HeaderNavHandlers {
  onNews: () => void;
  onOpportunities: () => void;
  onResources: () => void;
}

export function initHeader(nav?: HeaderNavHandlers) {
  const header = document.getElementById('header')!;

  header.innerHTML = `
    <a class="header-left" href="https://www.africandrone.org" target="_blank" rel="noopener noreferrer" style="text-decoration:none;color:inherit">
      <div class="header-logo">
        <img src="/logo.png" alt="africanDRONE logo" height="36" />
      </div>
      <div class="header-brand">
        <span class="header-title">africanDRONE</span>
        <span class="header-tagline">Worldwide Drone Regulations Map</span>
      </div>
    </a>
    <nav class="header-nav" aria-label="Primary">
      <button type="button" class="header-nav-btn" data-nav="news" title="News">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/>
          <path d="M18 14h-8"/><path d="M15 18h-5"/><path d="M10 6h8v4h-8V6Z"/>
        </svg>
        <span class="header-nav-label">News</span>
      </button>
      <button type="button" class="header-nav-btn" data-nav="opportunities" title="Opportunities">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/>
        </svg>
        <span class="header-nav-label">Opportunities</span>
      </button>
      <button type="button" class="header-nav-btn" data-nav="resources" title="Resources">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
        </svg>
        <span class="header-nav-label">Resources</span>
      </button>
    </nav>
    <div class="header-right">
      <a
        href="https://chat.whatsapp.com/EA0Yd3hkWKX3KlEKywmw2L"
        target="_blank"
        rel="noopener noreferrer"
        class="btn-whatsapp"
        title="Join our WhatsApp community"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
        </svg>
        <span class="btn-whatsapp-text">WhatsApp</span>
      </a>
      <a
        href="https://africandrone.org/drone-hotline"
        target="_blank"
        rel="noopener noreferrer"
        class="btn-suggest"
        title="Suggest an update to our data"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        <span class="btn-suggest-text">Suggest an Update</span>
      </a>
    </div>
  `;

  // Scoped styles for the primary nav. Kept here so the shared stylesheet
  // (owned by another agent) does not need to change.
  if (!document.getElementById('header-nav-styles')) {
    const style = document.createElement('style');
    style.id = 'header-nav-styles';
    style.textContent = `
      .header-nav {
        display: flex;
        align-items: center;
        gap: 4px;
        margin: 0 auto;
      }
      .header-nav-btn {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        padding: 7px 14px;
        font-size: 13px;
        font-weight: 600;
        font-family: var(--font-body, system-ui, sans-serif);
        letter-spacing: 0.2px;
        color: #d7dde5;
        background: none;
        border: 1px solid transparent;
        border-radius: 9px;
        cursor: pointer;
        transition: all var(--transition-normal, 0.15s ease);
      }
      .header-nav-btn:hover {
        color: #fff;
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.18);
      }
      .header-nav-btn svg { flex-shrink: 0; }
      @media (max-width: 640px) {
        .header-nav { gap: 2px; margin: 0; }
        .header-nav-label { display: none; }
        .header-nav-btn { padding: 7px 9px; }
      }
    `;
    document.head.appendChild(style);
  }

  // Wire the nav buttons to the shared actions.
  if (nav) {
    const wire = (id: string, fn: () => void) => {
      header.querySelector<HTMLButtonElement>(`.header-nav-btn[data-nav="${id}"]`)
        ?.addEventListener('click', fn);
    };
    wire('news', nav.onNews);
    wire('opportunities', nav.onOpportunities);
    wire('resources', nav.onResources);
  }
}
